import { Theme } from "@mui/material";

const MuiInputBase = (theme: Theme) => ({
  styleOverrides: {
    root: {
      "&:before": {
        borderBottomColor: theme.palette.text.primary,
      },
      "&&:after": {
        borderBottomColor: theme.palette.text.primary,
      },
    },
  },
});
export default MuiInputBase;
